import * as React from "react";
import {Link, Trans} from "gatsby-plugin-react-i18next";
import {StaticImage} from "gatsby-plugin-image";

const Blog = ({key, date, title, description, blogImage, slug}) => {
	return (
		<>
			<div className="px-3  z-10 h-702 relative">
				<Link to={`/posts/${slug}`} key={key}>
					<div className="max-w-392  bg-white  rounded-lg">
						{blogImage &&
						<img src={blogImage} alt={title} className="w-full h-72 object-cover"/>
						}
						{!blogImage &&
						<StaticImage
							alt="Logo"
							src="../images/logo.png"
							className="w-full h-72 object-cover"
						/>
						}
						<div className="px-6 flex flex-col">
							<p className="pt-4 pb-3 font-normal text-xs text-grey-normal">
								{date}
							</p>
							<h4 className="pb-2 font-semibold text-2xl truncate text-grey-normal ">
								{title}
							</h4>
							<p className="font-normal text-base pb-6">{description}</p>
							<div>
								<Link to={`/posts/${slug}`}>
									<div className="flex justify-end">
										<div className="self-end mb-6 text-grey-blue   border-b border-grey-blue cursor-pointer">
											<Trans>Read more</Trans>
										</div>
									</div>
								</Link>
							</div>
						</div>
					</div>
				</Link>
			</div>
		</>
	);
};

export default Blog;
